// eslint-disable-next-line no-unused-vars
import { all, takeEvery, takeLatest, take, put, call, select, getContext } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import { notification } from 'antd'
// import { history } from 'App'
// import { push } from 'react-router-redux'
// import { useNavigate } from 'react-router-dom'
import _ from 'lodash'

import * as ko from 'locales/ko-KR'
import * as en from 'locales/en-US'
import * as firebase from 'services/firebase'
// import { USER } from 'constant'
import PATH from 'path.config'
import { fireStore } from '../../firebase'
import actions from './actions'

let locale = ko.default
if (process.env.REACT_APP_LOCALE === 'en-US') {
  locale = en.default
}

// eslint-disable-next-line no-unused-vars
const delay = (time) => new Promise((resolve) => setTimeout(resolve, time))

// const redirectTo = location => {
//   history.push(location)
// }

export function* LOGIN({ payload }) {
  const { email, password } = payload
  // const settings = yield select((state) => state.Project.settings)
  // const { multiSignInAllowed } = settings
  // console.log('multi Sign in allowed', multiSignInAllowed)

  // console.log(payload)
  // let loginRedirectPath = PATH.HOME
  // if (redirect) {
  //   loginRedirectPath = redirect
  // }
  const success = yield call(firebase.login, email, password)
  // console.log(success);

  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    // yield put({
    //   type: 'user/SET_STATE',
    //   payload: {
    //     authorized: true,
    //   },
    // })
    // const history = yield getContext('history')
    // history.push('/')
    // yield history.push(loginRedirectPath)

    // notification.success({
    //   message: '로그인',
    //   description: 'Welcome to Tech seminar 2021',
    //   duration: 2,
    // })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* LOGOUT({ payload }) {
  // console.log('logout saga')
  // const navigate = useNavigate()

  // eslint-disable-next-line no-unused-vars
  const result = yield call(firebase.logout)
  const initialUser = {
    type: 'user/SET_STATE',
    payload: {
      id: '',
      profile: {},
      role: '',
      email: '',
      allowed: false,
      surveyAllowed: false,
      chatAllowed: false,
      completedSurveys: [],
      authorized: false,
      loading: false,
      blocked: false,
      loginToken: '',
      acceptableSchedules: null,
      defaultSchedule: null,
      authProvider: null,
      signUpFinished: false,
      naverProfile: null,
      naverAccessToken: null,
    },
  }
  yield put(initialUser)
  if (payload) {
    // console.log('logout and move to url', payload.url)
    const { url, navigate } = payload
    yield put(navigate(url))
  }
}

export function* REGISTER({ payload }) {
  // eslint-disable-next-line no-unused-vars
  const { email, password, ...data } = payload

  yield put({
    type: 'user/SET_STATE',
    payload: {
      authorized: false,
    },
  })

  const settings = yield select((state) => state.Project.settings)

  // yield put(push(PATH.AUTH.REGISTER_COMPLETE))s

  data.allowed = true
  data.surveyComplete = false
  // eslint-disable-next-line no-unused-vars

  let defaultAllowedSchedules = []
  let defaultUserSchedule = null
  if (settings && _.has(settings, 'defaultAllowedSchedules')) {
    // eslint-disable-next-line prefer-destructuring
    // console.log('settings.defaultAllowedSchedules', settings.defaultAllowedSchedules)
    defaultAllowedSchedules = settings.defaultAllowedSchedules
  }
  if (settings && _.has(settings, 'defaultUserSchedule')) {
    // eslint-disable-next-line prefer-destructuring
    // console.log('settings.defaultUserSchedule', settings.defaultUserSchedule)
    defaultUserSchedule = settings.defaultUserSchedule
  }

  data.acceptableSchedules = defaultAllowedSchedules || []
  data.defaultSchedule = defaultUserSchedule || null

  if (_.has(data, 'profile') === false) {
    data.profile = null
  }
  if (data.profile) {
    _.forEach(data.profile, (value, key) => {
      // console.log('=>', key, value)
      if (!value) {
        data.profile[key] = null
      }
      if (value.constructor === Object) {
        data.profile[key] = _.omitBy(value, _.isNil)
      }
    })
  }

  const success = yield call(firebase.register, email, password, data)

  // return
  // eslint-disable-next-line no-unreachable
  // const success = true
  // yield call(delay, 2000)
  // const success = true
  // const history = yield getContext('history')
  // history.push('/')
  if (success) {
    // yield history.push(PATH.AUTH.REGISTER_COMPLETE)
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield put({
      type: 'user/SET_STATE',
      payload: {
        authorized: true,
      },
    })
    notification.success({
      message: 'Success',
      description: 'Registration Complete.',
      duration: 2,
    })

    if (settings.registerSurveyId) {
      const surveyPath = `${PATH.SURVEY}/${settings.registerSurveyId}`
      console.log(surveyPath)
      // yield history.push(surveyPath)
    } else {
      // yield history.push(PATH.AUTH.REGISTER_COMPLETE)
    }
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
    // yield history.push(PATH.AUTH.REGISTER_FAILED)
  }
}

export function* USER_EDIT({ payload }) {
  // console.log('USER_EDIT', payload)
  // const { email, name, nickname, phone, department, work, attendance, type, role } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(firebase.updateUser, payload)
  if (success) {
    notification.success({
      message: '수정 완료.',
      description: '참가자 정보가 수정되었습니다.',
      duration: 1,
    })
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}
export function* USER_DELETE({ payload }) {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  // console.log(firebase.updateUser)
  const success = yield call(firebase.deleteUser, payload)
  if (success) {
    notification.success({
      message: '삭제 완료.',
      description: '참가자가 삭제되었습니다.',
      duration: 1,
    })
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOAD_CURRENT_ACCOUNT() {
  // console.log('LOAD CURRENT USER STARTED')
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  // console.log('load currentuser')
  const user = yield call(firebase.currentAccount)

  // console.log('sagas', user)
  if (user) {
    const ref = fireStore.collection('users').doc(user.uid)
    const channel = eventChannel((emit) => ref.onSnapshot(emit))

    try {
      while (true) {
        const settings = yield select((state) => state.Project.settings)
        // console.log(settings)
        let multiSignInAllowed = true
        if (settings && _.has(settings, 'multiSignInAllowed')) {
          multiSignInAllowed = settings.multiSignInAllowed
        }

        const profileData = yield take(channel)
        // console.log(profileData.data())
        const {
          role,
          email,
          profile,
          allowed,
          surveyAllowed,
          chatAllowed,
          completedSurveys,
          blocked,
          loginToken,
          acceptableSchedules,
          defaultSchedule,
          authProvider,
          signUpFinished,
          naverAccessToken,
          naverAuthType,
          naverProfile,
        } = profileData.data()

        // console.log('currentUser', loginToken)

        if (blocked === true) {
          channel.close()
          notification.error({
            message: '로그인 허용되지 않음',
            description: '로그인이 허용되어 있지 않습니다. 관리자에게 문의해 주세요.',
            duration: 5,
          })
          yield put({
            type: 'user/LOGOUT',
          })
        } else {
          if (multiSignInAllowed === false) {
            // console.log('multi sign in allowed', multiSignInAllowed)
            // console.log(loginToken, localStorage.getItem('signInToken'))
            if (loginToken !== localStorage.getItem('signInToken')) {
              channel.close()
              notification.error({
                message: locale.messages['auth.error.multiSignIn.title'],
                description: locale.messages['auth.error.multiSignIn.description'],
                duration: 5,
              })
              yield put({
                type: 'user/LOGOUT',
              })
            }
          }

          const userData = {
            id: user.uid,
            role,
            email,
            surveyAllowed: surveyAllowed || false,
            chatAllowed: chatAllowed || false,
            completedSurveys: completedSurveys || [],

            profile,
            authorized: true,
            blocked: blocked || false,
            loginToken: loginToken || null,
            allowed: allowed || false,
            acceptableSchedules: acceptableSchedules || [],
            defaultSchedule: defaultSchedule || null,
            authProvider: authProvider || null,
            signUpFinished: signUpFinished || false,
            naverAccessToken: naverAccessToken || null,
            naverAuthType: naverAuthType || null,
            naverProfile: naverProfile || null,
          }
          // if (authProvider === 'NAVER' && signUpFinished === false) {
          //   const naverProfile = yield call(firebase.getNaverProfile)
          // }
          yield put({
            type: 'user/SET_STATE',
            payload: { ...userData, loading: false },
          })
        }
      }
    } catch (_error) {
      console.log(_error)
    }
  }
  // console.log('LOAD CURRENT USER FINISHED')
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* FORGOT_PASSWORD({ payload }) {
  // console.log(payload)
  const result = yield call(firebase.sendFindPasswordMail, payload.email)
  // console.log(result)
  // const history = yield getContext('history')
  // history.push('/')
  if (result) {
    // yield history.push(PATH.AUTH_LOGIN)
    notification.success({
      message: '비밀번호 찾기 메일이 전송되었습니다.',
      description: '메일을 확인하시고 비밀번호를 재 설정 해 주세요',
      duration: 3,
    })
  } else {
    notification.error({
      message: '메일 발송 실패',
      description: '이메일 주소를 찾을 수 없습니다.',
      duration: 3,
    })
  }
}

export function* SET_PAGE({ payload }) {
  if (payload.user && payload.user.authorized && payload.user.id && payload.location) {
    const data = {
      id: payload.user.id,
      values: { lastOnPage: payload.location.pathname || null },
    }
    yield call(firebase.updateUser, data)
  }
}

export function* SET_NAVER_ACCESS_TOKEN({ payload }) {
  const { accessToken } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      naverAccessToken: accessToken,
      loading: false,
    },
  })
}
export function* LOGIN_NAVER({ payload }) {
  // console.log('LOGIN_NAVER', payload)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { code } = payload
  const profileResult = yield call(firebase.loginWithNaver, code)
  // console.log('🚀 [n:435]~ profileResult:', profileResult)

  if (profileResult) {
    if (profileResult.isNewUser === true) {
      const settings = yield select((state) => state.Project.settings)

      const data = {}
      let defaultAllowedSchedules = []
      let defaultUserSchedule = null
      if (settings && _.has(settings, 'defaultAllowedSchedules')) {
        defaultAllowedSchedules = settings.defaultAllowedSchedules
      }
      if (settings && _.has(settings, 'defaultUserSchedule')) {
        defaultUserSchedule = settings.defaultUserSchedule
      }
      data.acceptableSchedules = defaultAllowedSchedules || []
      data.defaultSchedule = defaultUserSchedule || null
      data.naverAccessToken = profileResult.token || null
      data.naverAuthType = 'REGISTER'
      data.naverProfile = profileResult.profile || null
      yield call(firebase.registerNaverUser, data)
    } else {
      const tokenData = {
        values: {
          naverAccessToken: profileResult.token,
          naverAuthType: 'SIGNIN',
          naverProfile: profileResult.profile,
        },
      }
      // console.log('naver profile exists user', profileResult.profile)
      yield call(firebase.updateUser, tokenData)
    }
  }

  yield put({
    type: 'user/LOAD_CURRENT_ACCOUNT',
  })

  // console.log('LOGIN NAVER FINISHED')
}

export function* GET_NAVER_PROFILE() {
  const userData = yield call(firebase.getCurrentUserData)
  // console.log('GET_NAVER_PROFILE', userData.naverAccessToken, userData.naverProfile)
  if (userData.naverAccessToken && !userData.naverProfile) {
    // console.log('get naver user data', userData)
    const naverProfile = yield call(firebase.getNaverProfile, userData.naverAccessToken)
    // console.log('naverProfile', naverProfile)
    if (naverProfile === null) {
      yield put({
        type: 'user/LOGOUT',
      })
    } else {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          naverProfile: naverProfile,
          loading: false,
        },
      })
    }
  }
}

export function* REGISTER_NAVER_PROFILE({ payload }) {
  // const { user, profile } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const values = {
    ...payload.profile,
    signUpFinished: true,
  }
  const data = {
    values: values,
  }
  yield call(firebase.updateUser, data)
  yield put({
    type: 'user/LOAD_CURRENT_ACCOUNT',
  })
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGIN_CODE({ payload }) {
  // console.log('LOGIN_NAVER', payload)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { code } = payload
  const token = yield call(firebase.getTokenByCode, code)
  // console.log('get login token', token)
  if (token) {
    const result = yield call(firebase.loginWithToken, token)
    if (result) {
      notification.success({
        message: 'Signed In',
        description: 'Sign in with Message',
        duration: 1,
      })
      yield put({
        type: 'user/LOAD_CURRENT_ACCOUNT',
      })
    }
  } else {
    notification.error({
      message: 'Signed In',
      description: 'Access code expired.',
      duration: 10,
    })
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
        error: 'Access code expired.',
      },
    })
  }
  // console.log('🚀 [n:435]~ profileResult:', profileResult)

  // console.log('LOGIN NAVER FINISHED')
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.REGISTER_NAVER_PROFILE, REGISTER_NAVER_PROFILE),
    takeEvery(actions.LOGIN_NAVER, LOGIN_NAVER),
    takeEvery(actions.LOGIN_CODE, LOGIN_CODE),
    takeEvery(actions.GET_NAVER_PROFILE, GET_NAVER_PROFILE),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    takeEvery(actions.USER_DELETE, USER_DELETE),
    takeEvery(actions.USER_EDIT, USER_EDIT),
    takeEvery(actions.FORGOT_PASSWORD, FORGOT_PASSWORD),
    takeEvery(actions.SET_PAGE, SET_PAGE),
    takeEvery(actions.SET_NAVER_ACCESS_TOKEN, SET_NAVER_ACCESS_TOKEN),

    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
